import { ChatbotConfigurationInterface } from '../interfaces';
import { ApiChatbotRequestInterface } from '../interfaces/api';

export const mapQuestionRequest = (
    { customerKey, projectKey, apiKey, culture }: ChatbotConfigurationInterface,
    question: string,
    sessionId?: string,
    dialogPath?: string
): Partial<ApiChatbotRequestInterface> => ({
    customerKey,
    projectKey,
    apiKey,
    classificationId: 1,
    culture,
    'dim.VAStyle': 'VA',
    requestContext: 'VA',
    q: question,
    ...(sessionId && { 'session.id': sessionId }),
    ...(dialogPath && { 'session.dialogPath': dialogPath })
});
